$('html').removeClass('noJs');